import LabServiceModel from "@/models/LabServiceModel";

export default class MeasureUnitModel extends LabServiceModel {
  modelName() {
    return "unit-of-measure";
  }
  defaults() {
    return {
      id: null,
      type: null,
      name: null,
      abbrev: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      type: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      abbrev: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
}
